import { USER_ORGANIZATION_RELATION } from '../userScope.model.js';
import { isUserInternal } from '../userScope.utils.js';
export const DIMENSIONS_DATATABLE = [
    'class_desc',
    'sub_class_desc',
    'department_desc',
    'grp_class_desc',
    'main_holding_desc',
    'bem_merchandise_desc',
    'supplier_root_desc',
    'supplier_desc',
    'brand_type_desc',
    'brand_desc',
    'barcode',
    'store_chain_type_desc',
    'store_region_desc',
    'store_key',
    'assort_key',
    'ch_typo_key',
    'activity_type',
    'store_int_flag_desc',
    'bcp_chain_desc',
    'customer_movement_type',
    'customer_movement_type_detailed_key',
    'competitor_desc_anonymized',
    'brand_desc_anonymized',
    'brand_desc_anonymized',
    'barcode_anonymized',
    'item_key_anonymized',
    'item_desc_anonymized',
    'business_brand',
    'date_key_evolution_month',
    'date_key_evolution_week',
    'date_key_evolution_date',
    'business_brand_reduced',
    'trad_consostyle_macro_desc',
    'trad_consostyle_micro_desc',
    'trad_lifestage_macro_desc',
    'trad_lifestage_micro_desc'
];
export function isDataTableDimensionsType(value) {
    return DIMENSIONS_DATATABLE.includes(value);
}
const DEFAULT_DIMENSIONS_DATA_TABLE = [
    'department_desc',
    'grp_class_desc',
    'class_desc',
    'sub_class_desc',
    'main_holding_desc',
    'bem_merchandise_desc',
    'supplier_root_desc',
    'supplier_desc',
    'brand_type_desc',
    'brand_desc',
    'barcode',
    'activity_type',
    'store_chain_type_desc',
    'store_region_desc',
    'store_key',
    'store_int_flag_desc',
    'bcp_chain_desc',
    'business_brand',
    'business_brand_reduced'
];
const NIELSEN_UNAVAILABLE_DIMENSIONS = [
    'store_chain_type_desc',
    'store_region_desc',
    'store_key',
    'assort_key',
    'ch_typo_key',
    'activity_type',
    'store_int_flag_desc',
    'bcp_chain_desc',
    'customer_movement_type',
    'date_key_evolution_month',
    'date_key_evolution_week',
    'date_key_evolution_date',
    'customer_movement_type_detailed_key',
    'business_brand',
    'business_brand_reduced',
    'trad_consostyle_macro_desc',
    'trad_consostyle_micro_desc',
    'trad_lifestage_macro_desc',
    'trad_lifestage_micro_desc'
];
export const DEFAULT_SELECTED_DIMENSIONS_DATA_TABLE = {
    salesAmountDetail: ['department_desc'],
    salesQuantityDetail: ['department_desc'],
    businessEquationAllCustomersDetail: ['department_desc'],
    businessEquationCardholdersNonCardholdersDetail: ['department_desc'],
    dnDvDetail: ['barcode'],
    customerSegmentationConsostyle: ['trad_consostyle_macro_desc'],
    customerSegmentationLifestage: ['trad_lifestage_macro_desc']
};
const CUSTOMER_SEGMENTATION_CONSOSTYLE_SPECIFIC_DIMENSIONS = [
    'trad_consostyle_macro_desc',
    'trad_consostyle_micro_desc'
];
const CUSTOMER_SEGMENTATION_LIFESTAGE_SPECIFIC_DIMENSIONS = [
    'trad_lifestage_macro_desc',
    'trad_lifestage_micro_desc'
];
export const CUSTOMER_SEGMENTATION_SPECIFIC_DIMENSIONS = [
    ...CUSTOMER_SEGMENTATION_CONSOSTYLE_SPECIFIC_DIMENSIONS,
    ...CUSTOMER_SEGMENTATION_LIFESTAGE_SPECIFIC_DIMENSIONS
];
const CUSTOMER_SEGMENTATION_BASE_DIMENSIONS = [
    'department_desc',
    'grp_class_desc',
    'class_desc',
    'sub_class_desc',
    'main_holding_desc',
    'bem_merchandise_desc',
    'supplier_root_desc',
    'supplier_desc',
    'brand_type_desc',
    'business_brand',
    'business_brand_reduced',
    'brand_desc',
    'barcode',
    'activity_type',
    'store_chain_type_desc',
    'store_region_desc',
    'store_key',
    'store_int_flag_desc'
];
export const DIMENSIONS_PER_DATA_TABLE_VIEW = {
    possessionZoomPage: [
        'department_desc',
        'grp_class_desc',
        'class_desc',
        'sub_class_desc',
        'assort_key',
        'ch_typo_key',
        'brand_desc',
        'barcode',
        'brand_type_desc',
        'store_region_desc',
        'store_chain_type_desc',
        'store_key',
        'main_holding_desc',
        'bem_merchandise_desc',
        'supplier_root_desc',
        'supplier_desc',
        'store_int_flag_desc',
        'bcp_chain_desc'
    ],
    possessionZoomPageWithTheoretical: [
        'department_desc',
        'grp_class_desc',
        'class_desc',
        'sub_class_desc',
        'assort_key',
        'ch_typo_key',
        'brand_desc',
        'barcode',
        'brand_type_desc',
        'store_region_desc',
        'store_key',
        'store_chain_type_desc',
        'main_holding_desc',
        'bem_merchandise_desc',
        'supplier_root_desc',
        'supplier_desc',
        'store_int_flag_desc',
        'bcp_chain_desc'
    ],
    projectDetail: [
        'department_desc',
        'grp_class_desc',
        'class_desc',
        'sub_class_desc',
        'main_holding_desc',
        'bem_merchandise_desc',
        'supplier_root_desc',
        'supplier_desc',
        'brand_type_desc',
        'brand_desc',
        'barcode',
        'store_chain_type_desc',
        'store_region_desc',
        'store_key',
        'business_brand',
        'business_brand_reduced'
    ],
    competitorVision: [
        'competitor_desc_anonymized',
        'department_desc',
        'grp_class_desc',
        'class_desc',
        'sub_class_desc',
        'brand_desc_anonymized',
        'barcode_anonymized',
        'activity_type',
        'store_chain_type_desc',
        'store_region_desc',
        'store_key',
        'store_int_flag_desc',
        'business_brand',
        'business_brand_reduced'
    ],
    dynamicClient: [
        'customer_movement_type',
        'customer_movement_type_detailed_key',
        'department_desc',
        'grp_class_desc',
        'class_desc',
        'sub_class_desc',
        'main_holding_desc',
        'bem_merchandise_desc',
        'supplier_root_desc',
        'supplier_desc',
        'brand_type_desc',
        'brand_desc',
        'barcode',
        'store_chain_type_desc',
        'store_region_desc',
        'store_key',
        'store_int_flag_desc',
        'activity_type',
        'bcp_chain_desc',
        'business_brand',
        'business_brand_reduced'
    ],
    customerSegmentationConsostyle: [
        ...CUSTOMER_SEGMENTATION_CONSOSTYLE_SPECIFIC_DIMENSIONS,
        ...CUSTOMER_SEGMENTATION_BASE_DIMENSIONS
    ],
    customerSegmentationLifestage: [
        ...CUSTOMER_SEGMENTATION_LIFESTAGE_SPECIFIC_DIMENSIONS,
        ...CUSTOMER_SEGMENTATION_BASE_DIMENSIONS
    ]
};
export const getDimensionsForView = (dataTableView) => {
    if (!dataTableView) {
        return [...DEFAULT_DIMENSIONS_DATA_TABLE];
    }
    return DIMENSIONS_PER_DATA_TABLE_VIEW[dataTableView] ?? [...DEFAULT_DIMENSIONS_DATA_TABLE];
};
const DIMENSION_TO_GRANULARITY = {
    class_desc: undefined,
    sub_class_desc: undefined,
    department_desc: undefined,
    grp_class_desc: undefined,
    main_holding_desc: ['holding'],
    bem_merchandise_desc: ['holding'],
    supplier_root_desc: ['localSupplier', 'competitorVision'],
    supplier_desc: ['subSupplier'],
    brand_type_desc: ['brandType'],
    brand_desc: ['brand'],
    barcode: ['ean'],
    store_chain_type_desc: ['chainType'],
    store_region_desc: ['region'],
    store_key: ['stores'],
    assort_key: ['assortmentTypology'],
    ch_typo_key: ['productTypology'],
    activity_type: ['activityType'],
    store_int_flag_desc: ['storeType'],
    bcp_chain_desc: ['banner'],
    customer_movement_type: ['dynamicClientZoomPage'],
    customer_movement_type_detailed_key: ['dynamicClientZoomPage'],
    competitor_desc_anonymized: ['competitorVision'],
    brand_desc_anonymized: ['competitorVision'],
    barcode_anonymized: ['competitorVision'],
    item_key_anonymized: ['competitorVision'],
    item_desc_anonymized: ['competitorVision'],
    date_key_evolution_month: ['dateGranularity'],
    date_key_evolution_date: ['dateGranularity'],
    date_key_evolution_week: ['dateGranularity'],
    business_brand: ['businessBrand'],
    business_brand_reduced: ['businessBrand'],
    trad_consostyle_macro_desc: ['customerSegmentation'],
    trad_consostyle_micro_desc: ['customerSegmentation'],
    trad_lifestage_macro_desc: ['customerSegmentation'],
    trad_lifestage_micro_desc: ['customerSegmentation']
};
export const DIMENSION_TO_USER_ORGANIZATION_RELATION = {
    business_brand: 'internal',
    business_brand_reduced: 'external'
};
export function filterDimensionsByUserScopeAndReferential({ dimensions, taxonomy, userScope }) {
    const userOrganizationType = isUserInternal(userScope)
        ? USER_ORGANIZATION_RELATION.internal
        : USER_ORGANIZATION_RELATION.external;
    return dimensions.filter((dimension) => {
        // Remove  dimensions not available in Nielsen referential
        if (taxonomy === 'nielsen' && NIELSEN_UNAVAILABLE_DIMENSIONS.includes(dimension)) {
            return false;
        }
        // Remove dimension depending either if the organization is internal or not
        if (DIMENSION_TO_USER_ORGANIZATION_RELATION[dimension] &&
            DIMENSION_TO_USER_ORGANIZATION_RELATION[dimension] !== userOrganizationType) {
            return false;
        }
        const requiredGranularity = DIMENSION_TO_GRANULARITY[dimension];
        if (!requiredGranularity) {
            return true;
        }
        return requiredGranularity.some((granularity) => userScope.permissions.kpis.includes(granularity));
    });
}
// Array containing possible date granularity dimensions.
// The actual dimension will be selected later based on the period field.
export const DATE_GRANULARITY_DIMENSIONS = [
    'date_key_evolution_date',
    'date_key_evolution_month',
    'date_key_evolution_week'
];
// Datatables where the date granularity dimension should be available
export const DATE_GRANULARITY_DIMENSION_DATATABLES = [
    'salesAmountDetail',
    'salesQuantityDetail',
    'businessEquationAllCustomersDetail',
    'businessEquationCardholdersNonCardholdersDetail'
];
//# sourceMappingURL=dimensions.model.js.map